import { render, staticRenderFns } from "./DiagnosticSectionLayout.vue?vue&type=template&id=b96d046c&scoped=true&"
import script from "./DiagnosticSectionLayout.vue?vue&type=script&lang=js&"
export * from "./DiagnosticSectionLayout.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticSectionLayout.vue?vue&type=style&index=0&id=b96d046c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96d046c",
  null
  
)

export default component.exports